<div  class="tCol clickCol desktop" id="CellOS_{{ item.name }}">
    <div class="chartWrapper" >
        <p-chart
        type="line"
        [data]="data"
        [options]="options"
        [width]="300" 
        [height]="40" 
        ></p-chart>
    </div>
</div>

